
import { defineComponent, onBeforeMount, reactive } from 'vue'

// Components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// Classes
import { DataState } from '@/core/classes/DataState.class'

// Types
import { CompanyT } from '@/core/types/companies.types'
import { TmcT } from '@/core/types/tmc.types'

// Realisations
import { companies } from '@/core/realisations/companies.realisation'
import { tmc } from '@/core/realisations/tmc.realisation'

// Constants
const STATUSES = [
    {
        id: 1,
        name: 'В ожидании',
    },
    {
        id: 2,
        name: 'Завершен',
    },
    {
        id: 3,
        name: 'Отменен',
    },
]

export default defineComponent({
    components: {
        'the-button': TheButton,
        'the-select': TheSelect,
        'the-input': TheInput,
        Checkbox,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const state = reactive({
            id: null as string | null,
            companyId: null as number | null,
            code1C: null as string | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            inventoryItemId: null as number | null,
            statusId: null as number | null,
            jiraNumber: null as string | null,
            warrantNumber: null as string | null,
            isSecondMaterial: null as number | null,
        })

        const data_state = reactive({
            companies: new DataState<CompanyT>({}),
            tmc: new DataState<TmcT>({}),
        })

        const resetFilters = () => {
            state.companyId = null
            state.code1C = null
            state.id = null
            state.createdAtFrom = null
            state.createdAtTo = null
            state.inventoryItemId = null
            state.statusId = null
            state.jiraNumber = null
            state.warrantNumber = null
            state.isSecondMaterial = null
        }

        const loadCompanies = async (page: number, search?: string) => {
            data_state.companies.pagination.current_page = page

            try {
                data_state.companies.is_loading = true

                const params = { getAll: 1, limit: 9999, isExtended: 0, search }
                const response = await companies.getListBilling(params)
                data_state.companies.list = response.data

                data_state.companies.pagination.total_pages = response.meta.last_page

                data_state.companies.is_failed = false
                data_state.companies.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.companies.failure.catchError(error)

                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_failed = true
                }
            } finally {
                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_loading = false
                }
            }
        }

        const loadTMC = async (page: number, search?: string) => {
            data_state.tmc.pagination.current_page = page

            try {
                data_state.tmc.is_loading = true
                const response = await tmc.getList(page, search)
                data_state.tmc.list = response.data

                data_state.tmc.pagination.total_pages = response.meta.last_page

                data_state.tmc.is_failed = false
                data_state.tmc.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.tmc.failure.catchError(error)

                if (!data_state.tmc.failure.error_state.is_cancel) {
                    data_state.tmc.is_failed = true
                }
            } finally {
                if (!data_state.tmc.failure.error_state.is_cancel) {
                    data_state.tmc.is_loading = false
                }
            }
        }

        const loadMoreTMC = async (page: number) => {
            if (page > data_state.tmc.pagination.total_pages) return
            data_state.tmc.pagination.current_page = page

            try {
                data_state.tmc.is_loading = true

                const response = await tmc.getList(page)
                data_state.tmc.list = data_state.tmc.list.concat(response.data)

                data_state.tmc.pagination.total_pages = response.meta.last_page

                data_state.tmc.is_failed = false
                data_state.tmc.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.tmc.failure.catchError(error)

                if (!data_state.tmc.failure.error_state.is_cancel) {
                    data_state.tmc.is_failed = true
                }
            } finally {
                if (!data_state.tmc.failure.error_state.is_cancel) {
                    data_state.tmc.is_loading = false
                }
            }
        }

        const searchTMC = (search_query: string) => {
            loadTMC(1, search_query)
        }

        const unshiftFindedTMC = async (tmc: TmcT) => {
            await loadTMC(data_state.tmc.pagination.current_page)
            data_state.tmc.list.unshift(tmc)
        }

        const initializeFilters = () => {
            loadCompanies(1)
            loadTMC(1)
        }

        onBeforeMount(initializeFilters)

        const onSubmit = () => {
            if (props.loading) return
            emit('submit', { ...state })
        }

        const onReset = () => {
            if (props.loading) return

            resetFilters()
            emit('reset')
        }

        return {
            STATUSES,
            state,
            data_state,
            loadCompanies,
            loadTMC,
            loadMoreTMC,
            searchTMC,
            unshiftFindedTMC,
            onSubmit,
            onReset,
        }
    },
})
